export default "__VITE_ASSET__B8RMcHD3__"